import { render, staticRenderFns } from "./aracseferno.vue?vue&type=template&id=2b64cfea&"
import script from "./aracseferno.vue?vue&type=script&lang=js&"
export * from "./aracseferno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports